import { Text } from '@mantine/core';
export function FeedbackError(): JSX.Element {
  return <Text>There was an error uploading your feedback</Text>;
}
